module.exports = __webpack_public_path__ + "media/images/Icon-check-done-2b4bb3cafe9c659406c4f7e0f690cac8.svg";